






























































































































































import RespondecoUnsavedBar from '../../../main/unsaved-bar.vue'
import VueSimpleSpinner from 'vue-simple-spinner'
import Component from 'vue-class-component'
import { loggerFor } from '@/shared/utils/logger'
import { Injector } from '@/config/dependency-injection'
import { OrganisationsModule } from '@/business/organisation/store/organisations-module'
import { activeUserIsAdmin, activeUserIsOwner, activeUserIsPremium } from '@/shared/utils/user'
import { FETCH_ORGANISATION } from '@/business/organisation/store/types'
import HttpError from '@/shared/components/http-error.vue'
import { HttpResponse } from '@/commons/types/http-response'
import UnifyHero from '@/shared/components/unify/unify-hero.vue'
import RespondecoImage from '@/shared/components/respondeco-image.vue'
import { Route } from 'vue-router'
import { BeforeRouteUpdate } from '@/shared/interfaces/before-route-update'
import { RouterNextFunction } from '@/shared/interfaces/router-next-function'
import Vue from 'vue'
import { imageUrl } from '@/shared/utils/images'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'
import { VueRouter } from 'vue-router/types/router'
import { RouterToken } from '@/config/injection-tokens'
import { Hooks } from '@/shared/interfaces/hooks'
import RespondecoTopBar from '@/main/respondeco-top-bar.vue'
import { impersonateOrganisation } from '@/authentication/utils/impersonate-organisation'

@Component({
  components: {
    RespondecoTopBar,
    RespondecoResponsiveImage,
    RespondecoImage,
    UnifyHero,
    HttpError,
    RespondecoUnsavedBar,
    VueSimpleSpinner,
  },
  data() {
    return {
      error: undefined,
    }
  },
})
export default class Organisation extends Vue implements BeforeRouteUpdate, Hooks {
  public error?: HttpResponse
  public id!: number

  public imageUrl = imageUrl

  public LOADING = FETCH_ORGANISATION

  private logger = loggerFor('Organisation')

  private organisationModule: OrganisationsModule = Injector.get(OrganisationsModule)
  private router = Injector.get<VueRouter>(RouterToken)

  get activeUserIsAdmin(): boolean {
    return activeUserIsAdmin()
  }

  get activeUserIsOwner(): boolean {
    return activeUserIsOwner(this.viewModel.organisation.id)
  }

  get activeUserIsPremium(): boolean {
    return activeUserIsPremium()
  }

  get organisation() {
    return this.viewModel.organisation
  }

  get viewModel() {
    return this.organisationModule.organisationViewModel
  }

  // Currently disabled as emptying the state will result in an error if the user is not allowed to
  // perform the navigation.
  //
  // public beforeRouteLeave(to: string, from: string, next: () => {}) {
  //   this.organisationModule.clearOrganisation()
  //
  //   next()
  // }

  public beforeRouteUpdate(to: Route, from: Route, next: RouterNextFunction) {
    // The id will be the same when navigating to child routes
    const routeId = parseInt(to.params.id, 10)

    if (routeId !== this.id) {
      this.id = routeId

      this.fetchData()

      scrollTo({
        top: 0,
      })
    }

    next()
  }

  public created() {
    this.id = parseInt(this.$route.params.id, 10)

    this.fetchData()

    if (this.router.currentRoute.name === 'organisation') {
      this.router.replace({
        name: 'organisation-about',
      })
    }
  }

  public mounted() {
    scrollTo({
      top: 0,
    })
  }

  public fetchData() {
    this.logger.debug('Fetching organisation', this.id)

    this.organisationModule.fetchOrganisation(this.id)
  }

  public impersonate() {
    impersonateOrganisation(this.organisation.id)
  }

  public setNewImage(image: any) {
    this.logger.info(image)
  }
}
